import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logoZuno from "../assets/zuno-logo.png";
import welcomePathOnboarding from "../assets/zuno/onboarding/welcome-path.png";
import passengerOnboarding from "../assets/zuno/onboarding/passenger.webp";
import driverOnboarding from "../assets/zuno/onboarding/driver.webp";
import safetyOnboarding from "../assets/zuno/onboarding/safety.webp";
import communityOnboarding from "../assets/zuno/onboarding/community.webp";
import "./SplashScreen.css";

// ─── SLIDES ────────────────────────────────────────────────────
const SLIDES = [
  {
    id: 0,
    tag: "BEM-VINDO",
    title: "Seu caminho\ncomeça aqui.",
    sub: "Mobilidade pensada para quem busca praticidade, confiança e liberdade em cada trajeto.",
    accent: "#22d3ee",
    accent2: "#c43cff",
    bg1: "rgba(34,211,238,0.18)",
    bg2: "rgba(196,60,255,0.10)",
    image: welcomePathOnboarding,
    visual: (
      <svg viewBox="0 0 320 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
        <defs>
          <radialGradient id="glow0" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#a855f7" stopOpacity="0.3"/>
            <stop offset="100%" stopColor="#a855f7" stopOpacity="0"/>
          </radialGradient>
        </defs>
        {/* Cidade */}
        <ellipse cx="160" cy="260" rx="130" ry="12" fill="rgba(0,0,0,0.3)"/>
        <circle cx="160" cy="140" r="120" fill="url(#glow0)"/>
        {/* Prédios */}
        <rect x="20" y="160" width="28" height="80" rx="3" fill="rgba(168,85,247,0.25)" stroke="rgba(168,85,247,0.4)" strokeWidth="1"/>
        <rect x="52" y="130" width="36" height="110" rx="3" fill="rgba(168,85,247,0.3)" stroke="rgba(168,85,247,0.5)" strokeWidth="1"/>
        <rect x="92" y="105" width="44" height="135" rx="3" fill="rgba(168,85,247,0.4)" stroke="rgba(168,85,247,0.6)" strokeWidth="1"/>
        <rect x="140" y="80" width="40" height="160" rx="3" fill="rgba(168,85,247,0.5)" stroke="rgba(168,85,247,0.7)" strokeWidth="1.5"/>
        <rect x="184" y="115" width="38" height="125" rx="3" fill="rgba(236,72,153,0.35)" stroke="rgba(236,72,153,0.5)" strokeWidth="1"/>
        <rect x="226" y="145" width="32" height="95" rx="3" fill="rgba(168,85,247,0.25)" stroke="rgba(168,85,247,0.4)" strokeWidth="1"/>
        <rect x="262" y="170" width="24" height="70" rx="3" fill="rgba(168,85,247,0.2)" stroke="rgba(168,85,247,0.3)" strokeWidth="1"/>
        {/* Janelas */}
        {[0,1,2,3].map(r => [0,1,2].map(c => (
          <rect key={`w-${r}-${c}`} x={96+c*12} y={112+r*18} width="6" height="8" rx="1" fill="rgba(255,255,255,0.12)"/>
        )))}
        {[0,1,2,3].map(r => [0,1].map(c => (
          <rect key={`w2-${r}-${c}`} x={144+c*16} y={88+r*20} width="8" height="10" rx="1" fill={r===1&&c===0?"rgba(255,255,200,0.5)":"rgba(255,255,255,0.1)"}/>
        )))}
        {/* Carro em movimento */}
        <g transform="translate(60,228)">
          <rect x="0" y="8" width="60" height="18" rx="5" fill="#a855f7"/>
          <path d="M8 8 L14 0 L44 0 L52 8Z" fill="#9333ea"/>
          <rect x="15" y="1" width="12" height="6" rx="1" fill="rgba(190,230,255,0.5)"/>
          <rect x="29" y="1" width="12" height="6" rx="1" fill="rgba(190,230,255,0.5)"/>
          <circle cx="12" cy="26" r="5" fill="#1a1a2e"/><circle cx="12" cy="26" r="2.5" fill="#6b21a8"/>
          <circle cx="48" cy="26" r="5" fill="#1a1a2e"/><circle cx="48" cy="26" r="2.5" fill="#6b21a8"/>
          <rect x="52" y="10" width="7" height="4" rx="1.5" fill="rgba(255,240,100,0.9)"/>
          {/* Rastro de luz */}
          <rect x="-40" y="14" width="35" height="2" rx="1" fill="rgba(168,85,247,0.3)"/>
          <rect x="-55" y="17" width="20" height="1" rx="0.5" fill="rgba(168,85,247,0.15)"/>
        </g>
        {/* Estrelas */}
        {[[25,40],[285,50],[300,110],[15,200],[295,200]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r={1.5} fill="rgba(255,255,255,0.5)"/>
        ))}
        {/* Pin central */}
        <path d="M160 35 C148 35 138 45 138 57 C138 72 160 90 160 90 C160 90 182 72 182 57 C182 45 172 35 160 35Z" fill="#ec4899"/>
        <circle cx="160" cy="57" r="8" fill="white" opacity="0.9"/>
        <circle cx="160" cy="57" r="4" fill="#ec4899"/>
      </svg>
    ),
  },
  {
    id: 1,
    tag: "PARA PASSAGEIROS",
    title: "Chegue onde\nquiser em\nminutos.",
    sub: "Solicite sua corrida em segundos. Motoristas próximos, rastreamento em tempo real.",
    accent: "#06b6d4",
    accent2: "#3b82f6",
    bg1: "rgba(6,182,212,0.15)",
    bg2: "rgba(59,130,246,0.10)",
    image: passengerOnboarding,
    visual: (
      <svg viewBox="0 0 320 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
        <defs>
          <radialGradient id="glow1" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#06b6d4" stopOpacity="0.2"/>
            <stop offset="100%" stopColor="#06b6d4" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <circle cx="160" cy="140" r="110" fill="url(#glow1)"/>
        {/* Mapa de fundo */}
        <rect x="30" y="40" width="260" height="200" rx="20" fill="rgba(6,182,212,0.06)" stroke="rgba(6,182,212,0.15)" strokeWidth="1"/>
        {/* Ruas */}
        <line x1="30" y1="140" x2="290" y2="140" stroke="rgba(255,255,255,0.06)" strokeWidth="10"/>
        <line x1="160" y1="40" x2="160" y2="240" stroke="rgba(255,255,255,0.06)" strokeWidth="10"/>
        <line x1="30" y1="100" x2="290" y2="100" stroke="rgba(255,255,255,0.04)" strokeWidth="5"/>
        <line x1="30" y1="180" x2="290" y2="180" stroke="rgba(255,255,255,0.04)" strokeWidth="5"/>
        {/* Rota curva */}
        <path d="M80 200 Q80 140 120 120 Q160 100 200 80 Q230 65 250 60" stroke="#06b6d4" strokeWidth="3" strokeDasharray="6 3" fill="none" strokeLinecap="round"/>
        {/* Origem */}
        <circle cx="80" cy="200" r="10" fill="rgba(6,182,212,0.3)" stroke="#06b6d4" strokeWidth="2"/>
        <circle cx="80" cy="200" r="4" fill="#06b6d4"/>
        <circle cx="80" cy="200" r="16" fill="none" stroke="#06b6d4" strokeWidth="1" opacity="0.3"/>
        <circle cx="80" cy="200" r="24" fill="none" stroke="#06b6d4" strokeWidth="0.5" opacity="0.15"/>
        {/* Destino — Pin */}
        <path d="M250 38 C241 38 233 46 233 55 C233 67 250 80 250 80 C250 80 267 67 267 55 C267 46 259 38 250 38Z" fill="#ec4899"/>
        <circle cx="250" cy="55" r="7" fill="white" opacity="0.9"/>
        <circle cx="250" cy="55" r="3.5" fill="#ec4899"/>
        {/* Carro na rota */}
        <circle cx="165" cy="105" r="18" fill="rgba(6,182,212,0.15)" stroke="#06b6d4" strokeWidth="1.5"/>
        <g transform="translate(152,97)">
          <rect x="0" y="6" width="26" height="12" rx="3" fill="#06b6d4"/>
          <path d="M4 6 L7 1 L19 1 L22 6Z" fill="#0891b2"/>
          <rect x="7" y="1.5" width="4" height="3.5" rx="0.5" fill="rgba(190,230,255,0.5)"/>
          <rect x="13" y="1.5" width="4" height="3.5" rx="0.5" fill="rgba(190,230,255,0.5)"/>
          <circle cx="6" cy="18" r="3.5" fill="#0c4a6e"/><circle cx="6" cy="18" r="1.5" fill="#0e7490"/>
          <circle cx="20" cy="18" r="3.5" fill="#0c4a6e"/><circle cx="20" cy="18" r="1.5" fill="#0e7490"/>
        </g>
        {/* Tempo ETA */}
        <rect x="110" y="68" width="72" height="28" rx="8" fill="rgba(6,182,212,0.2)" stroke="rgba(6,182,212,0.4)" strokeWidth="1"/>
        <text x="146" y="87" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#06b6d4">3 min</text>
        {/* Bolinhas decorativas */}
        {[[50,70],[270,180],[290,80],[40,160]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r={2} fill="rgba(6,182,212,0.4)"/>
        ))}
      </svg>
    ),
  },
  {
    id: 2,
    tag: "PARA MOTORISTAS",
    title: "Ganhe mais.\nTrabalhe no seu tempo.",
    sub: "100% da corrida é seu. Zero comissão abusiva. Você escolhe quando e quanto trabalhar.",
    accent: "#22c55e",
    accent2: "#10b981",
    bg1: "rgba(34,197,94,0.15)",
    bg2: "rgba(16,185,129,0.08)",
    image: driverOnboarding,
    visual: (
      <svg viewBox="0 0 320 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
        <defs>
          <radialGradient id="glow2" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#22c55e" stopOpacity="0.2"/>
            <stop offset="100%" stopColor="#22c55e" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <circle cx="160" cy="130" r="115" fill="url(#glow2)"/>
        {/* Moeda grande central */}
        <circle cx="160" cy="120" r="70" fill="rgba(34,197,94,0.1)" stroke="rgba(34,197,94,0.25)" strokeWidth="2"/>
        <circle cx="160" cy="120" r="56" fill="rgba(34,197,94,0.15)" stroke="rgba(34,197,94,0.3)" strokeWidth="1.5"/>
        <circle cx="160" cy="120" r="44" fill="rgba(34,197,94,0.2)" stroke="rgba(34,197,94,0.4)" strokeWidth="1"/>
        {/* R$ */}
        <text x="160" y="108" textAnchor="middle" fontSize="28" fontWeight="900" fill="#22c55e" opacity="0.95">R$</text>
        <text x="160" y="135" textAnchor="middle" fontSize="16" fontWeight="800" fill="rgba(34,197,94,0.8)">100%</text>
        <text x="160" y="152" textAnchor="middle" fontSize="10" fill="rgba(34,197,94,0.5)">SEUS</text>
        {/* Setas para cima animadas */}
        {[60,120,180,240].map((x,i) => (
          <g key={i}>
            <line x1={x} y1="220" x2={x} y2="195" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" opacity={0.4+i*0.15}/>
            <polyline points={`${x-5},202 ${x},195 ${x+5},202`} stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity={0.4+i*0.15}/>
          </g>
        ))}
        {/* Barras de ganho */}
        {[
          {x:35, h:50, label:"Seg"},
          {x:65, h:70, label:"Ter"},
          {x:95, h:45, label:"Qua"},
          {x:125, h:85, label:"Qui"},
          {x:220, h:60, label:"Sex"},
          {x:250, h:90, label:"Sab"},
          {x:280, h:40, label:"Dom"},
        ].map(({x,h,label}) => (
          <g key={label}>
            <rect x={x} y={240-h} width="18" height={h} rx="4" fill="rgba(34,197,94,0.25)" stroke="rgba(34,197,94,0.4)" strokeWidth="1"/>
            <text x={x+9} y="255" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.25)">{label}</text>
          </g>
        ))}
        {/* Brilhos */}
        {[[30,50],[290,70],[40,190],[295,180]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r={2} fill="rgba(34,197,94,0.5)"/>
        ))}
        <circle cx="90" cy="30" r="3" fill="rgba(34,197,94,0.4)"/>
        <circle cx="230" cy="25" r="2" fill="rgba(34,197,94,0.3)"/>
      </svg>
    ),
  },
  {
    id: 3,
    tag: "SEGURANÇA",
    title: "Sua viagem,\nprotegida do\ninício ao fim.",
    sub: "Rastreamento em tempo real, botão SOS, avaliações verificadas e suporte 24h.",
    accent: "#f59e0b",
    accent2: "#ef4444",
    bg1: "rgba(245,158,11,0.12)",
    bg2: "rgba(239,68,68,0.08)",
    image: safetyOnboarding,
    visual: (
      <svg viewBox="0 0 320 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
        <defs>
          <radialGradient id="glow3" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.2"/>
            <stop offset="100%" stopColor="#f59e0b" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <circle cx="160" cy="130" r="115" fill="url(#glow3)"/>
        {/* Escudo */}
        <path d="M160 30 L220 55 L220 120 C220 160 160 195 160 195 C160 195 100 160 100 120 L100 55 Z" fill="rgba(245,158,11,0.12)" stroke="rgba(245,158,11,0.4)" strokeWidth="2"/>
        <path d="M160 45 L210 66 L210 118 C210 152 160 182 160 182 C160 182 110 152 110 118 L110 66 Z" fill="rgba(245,158,11,0.08)" stroke="rgba(245,158,11,0.25)" strokeWidth="1"/>
        {/* Check dentro do escudo */}
        <polyline points="138,112 153,127 182,98" stroke="#f59e0b" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        {/* Itens de segurança */}
        <g transform="translate(30, 215)">
          <rect width="68" height="36" rx="10" fill="rgba(245,158,11,0.12)" stroke="rgba(245,158,11,0.3)" strokeWidth="1"/>
          <text x="34" y="14" textAnchor="middle" fontSize="8" fill="rgba(245,158,11,0.7)" fontWeight="700">🛡️ SOS</text>
          <text x="34" y="26" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.3)">Botão ativo</text>
        </g>
        <g transform="translate(126, 215)">
          <rect width="68" height="36" rx="10" fill="rgba(6,182,212,0.12)" stroke="rgba(6,182,212,0.3)" strokeWidth="1"/>
          <text x="34" y="14" textAnchor="middle" fontSize="8" fill="rgba(6,182,212,0.7)" fontWeight="700">📍 GPS</text>
          <text x="34" y="26" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.3)">Tempo real</text>
        </g>
        <g transform="translate(222, 215)">
          <rect width="68" height="36" rx="10" fill="rgba(34,197,94,0.12)" stroke="rgba(34,197,94,0.3)" strokeWidth="1"/>
          <text x="34" y="14" textAnchor="middle" fontSize="8" fill="rgba(34,197,94,0.7)" fontWeight="700">⭐ 5.0</text>
          <text x="34" y="26" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.3)">Verificado</text>
        </g>
        {/* Brilhos */}
        {[[40,50],[280,45],[30,160],[295,170]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r={2} fill="rgba(245,158,11,0.4)"/>
        ))}
      </svg>
    ),
  },
  {
    id: 4,
    tag: "COMUNIDADE",
    title: "Juntos,\ntransformamos\ncidades.",
    sub: "Motoristas e passageiros unidos por uma plataforma que respeita o ser humano acima de tudo.",
    accent: "#ec4899",
    accent2: "#a855f7",
    bg1: "rgba(236,72,153,0.15)",
    bg2: "rgba(168,85,247,0.10)",
    image: communityOnboarding,
    visual: (
      <svg viewBox="0 0 320 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
        <defs>
          <radialGradient id="glow4" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ec4899" stopOpacity="0.2"/>
            <stop offset="100%" stopColor="#ec4899" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <circle cx="160" cy="130" r="115" fill="url(#glow4)"/>
        {/* Nó central */}
        <circle cx="160" cy="120" r="28" fill="rgba(236,72,153,0.2)" stroke="rgba(236,72,153,0.5)" strokeWidth="2"/>
        <circle cx="160" cy="120" r="20" fill="rgba(236,72,153,0.3)"/>
        <text x="160" y="125" textAnchor="middle" fontSize="16" fontWeight="900" fill="white">Z</text>
        {/* Pulsos */}
        <circle cx="160" cy="120" r="36" fill="none" stroke="rgba(236,72,153,0.15)" strokeWidth="1.5"/>
        <circle cx="160" cy="120" r="48" fill="none" stroke="rgba(236,72,153,0.08)" strokeWidth="1"/>
        {/* Nós externos com papéis */}
        {[
          {cx:80,  cy:55,  c:"rgba(168,85,247,0.35)", sc:"rgba(168,85,247,0.7)", ic:"#c084fc", label:"Passageiro"},
          {cx:240, cy:55,  c:"rgba(6,182,212,0.35)",  sc:"rgba(6,182,212,0.7)",  ic:"#22d3ee", label:"Motorista"},
          {cx:55,  cy:175, c:"rgba(34,197,94,0.35)",  sc:"rgba(34,197,94,0.7)",  ic:"#4ade80", label:"Família"},
          {cx:265, cy:175, c:"rgba(245,158,11,0.35)", sc:"rgba(245,158,11,0.7)", ic:"#fbbf24", label:"Cidade"},
          {cx:160, cy:222, c:"rgba(239,68,68,0.35)",  sc:"rgba(239,68,68,0.7)",  ic:"#f87171", label:"Suporte"},
        ].map(({cx,cy,c,sc,ic,label},i) => (
          <g key={i}>
            {/* linha de conexão */}
            <line x1={cx} y1={cy} x2="160" y2="120" stroke={sc} strokeWidth="1.5" strokeDasharray="4 3" opacity="0.35"/>
            {/* bolinha de dado viajando na linha */}
            <circle r="3" fill={ic} opacity="0.8">
              <animateMotion dur={`${2+i*0.4}s`} repeatCount="indefinite" calcMode="linear">
                <mpath xlinkHref={`#path${i}`}/>
              </animateMotion>
            </circle>
            <path id={`path${i}`} d={`M${cx},${cy} L160,120`} fill="none"/>
            {/* círculo do nó */}
            <circle cx={cx} cy={cy} r="22" fill={c} stroke={sc} strokeWidth="2"/>
            {/* ícone de pessoa (cabeça + ombros) */}
            <circle cx={cx} cy={cy-5} r="7" fill={ic} opacity="0.85"/>
            <path d={`M${cx-12},${cy+18} Q${cx-12},${cy+6} ${cx},${cy+6} Q${cx+12},${cy+6} ${cx+12},${cy+18}`} fill={ic} opacity="0.85"/>
            {/* label abaixo */}
            <text x={cx} y={cy+38} textAnchor="middle" fontSize="9" fontWeight="700" fill={ic} letterSpacing="0.5">{label}</text>
          </g>
        ))}
        {/* Brilhos */}
        {[[25,35],[300,40],[20,240],[300,235]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r={1.5} fill="rgba(236,72,153,0.5)"/>
        ))}
      </svg>
    ),
  },
];

// ─── COMPONENTE PRINCIPAL ──────────────────────────────────────
// Incrementa quando o fluxo de boas-vindas precisa ser apresentado novamente.
// A versão 3 restaura os slides para quem atualizou o app e já tinha a versão 2
// salva no aparelho: animação nativa -> onboarding -> localização -> login.
const ONBOARDING_VERSION = "3";
const ONBOARDING_VERSION_KEY = "zunoOnboardingVersion";

function CinematicMotion({ id }) {
  return (
    <div className={`onboarding-motion onboarding-motion--${id}`} aria-hidden="true">
      <div className="motion-depth motion-depth--back" />
      <div className="motion-depth motion-depth--front" />
      <div className="motion-route"><i /></div>
      <div className="motion-focus"><i /></div>
      <div className="motion-nodes">
        {[0, 1, 2, 3, 4].map((item) => <i key={item} />)}
      </div>
      <div className="motion-particles">
        {[0, 1, 2, 3, 4, 5].map((item) => <i key={item} />)}
      </div>
    </div>
  );
}

export default function SplashScreen({ estaLogado, homeCorreta }) {
  const navigate = useNavigate();
  const [phase, setPhase]           = useState(() =>
    localStorage.getItem(ONBOARDING_VERSION_KEY) === ONBOARDING_VERSION ? "routing" : "onboarding"
  );
  const [slide, setSlide]           = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const [slideDir, setSlideDir]     = useState(1); // 1=próximo, -1=anterior
  const [touchStart, setTouchStart] = useState(null);
  const [touchDelta, setTouchDelta] = useState(0);

  // A cena de abertura vive nas camadas nativas de Android e iOS. Aqui fica somente a decisão
  // de onboarding/login para não exibir duas splash screens em sequência.
  useEffect(() => {
    const onboardingFeito = localStorage.getItem(ONBOARDING_VERSION_KEY) === ONBOARDING_VERSION;
    if (!onboardingFeito) return;

    const verificarENavegar = async () => {
      let locationAsked = localStorage.getItem("locationPermission");
      if (!locationAsked && navigator.permissions) {
        try {
          const r = await navigator.permissions.query({ name: "geolocation" });
          if (r.state === "granted") {
            localStorage.setItem("locationPermission", "granted");
            locationAsked = "granted";
          }
        } catch (_) {}
      }
      if (estaLogado) navigate(homeCorreta, { replace: true });
      else navigate(locationAsked ? "/login" : "/location-permission", { replace: true });
    };

    verificarENavegar();
  }, [navigate, estaLogado, homeCorreta]);

  // ── Navegação entre slides ──────────────────────────────────
  const goTo = (target, dir = 1) => {
    if (transitioning) return;
    setSlideDir(dir);
    setTransitioning(true);
    setTimeout(() => {
      setSlide(target);
      setTransitioning(false);
    }, 320);
  };

  const goNext = () => {
    if (slide < SLIDES.length - 1) goTo(slide + 1, 1);
    else setPhase("cta");
  };

  const goPrev = () => {
    if (slide > 0) goTo(slide - 1, -1);
  };

  const skip = () => {
    localStorage.setItem("zunoOnboardingDone", "1");
    localStorage.setItem(ONBOARDING_VERSION_KEY, ONBOARDING_VERSION);
    setPhase("cta");
  };

  // ── Touch ───────────────────────────────────────────────────
  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
    setTouchDelta(0);
  };
  const handleTouchMove = (e) => {
    if (touchStart === null) return;
    setTouchDelta(e.touches[0].clientX - touchStart);
  };
  const handleTouchEnd = () => {
    if (touchDelta > 55) goPrev();
    else if (touchDelta < -55) goNext();
    setTouchStart(null);
    setTouchDelta(0);
  };

  // ── Entrar ──────────────────────────────────────────────────
  const handleEntrar = () => {
    localStorage.setItem("zunoOnboardingDone", "1");
    localStorage.setItem(ONBOARDING_VERSION_KEY, ONBOARDING_VERSION);
    const locationAsked = localStorage.getItem("locationPermission");
    navigate(locationAsked ? "/login" : "/location-permission", { replace: true });
  };

  const cur = SLIDES[slide];
  const cinematic = Boolean(cur.image);

  return (
    <div className="zuno-splash" style={S.root}>
      <style>{`
        @keyframes floatY      { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
        @keyframes fadeUp      { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        @keyframes fadeIn      { from{opacity:0} to{opacity:1} }
        @keyframes pulseRing   { 0%,100%{transform:scale(1);opacity:0.5} 50%{transform:scale(1.08);opacity:1} }
        @keyframes slideInR    { from{opacity:0;transform:translateX(60px)} to{opacity:1;transform:translateX(0)} }
        @keyframes slideInL    { from{opacity:0;transform:translateX(-60px)} to{opacity:1;transform:translateX(0)} }
        @keyframes shimmerBar  { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
        @keyframes welcomeOrbit { to{transform:rotate(360deg)} }
        @keyframes welcomeOrbitReverse { to{transform:rotate(-360deg)} }
        @keyframes welcomeSphere { 0%,100%{transform:translateY(0) scale(1);filter:brightness(1)} 50%{transform:translateY(-7px) scale(1.025);filter:brightness(1.12)} }
        @keyframes welcomeBolt { 0%,100%{filter:drop-shadow(0 0 8px #fff) drop-shadow(0 0 18px #a855f7)} 50%{filter:drop-shadow(0 0 13px #fff) drop-shadow(0 0 30px #22d3ee)} }
        @keyframes welcomeCard { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }
        @keyframes welcomeButtonGlow { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
        @media (prefers-reduced-motion: reduce) { .welcome-motion { animation:none !important; } }
        * { box-sizing:border-box; -webkit-tap-highlight-color:transparent; user-select:none; }
      `}</style>

      {/* ── Fundo dinâmico ── */}
      <div style={{ position:"fixed", inset:0, zIndex:0, background:"linear-gradient(160deg,#04060f 0%,#07091c 50%,#04060f 100%)", overflow:"hidden" }}>
        {/* Orbs de cor por slide */}
        <div style={{ position:"absolute", top:"-10%", left:"-10%", width:"70vw", height:"70vw", maxWidth:500, maxHeight:500, borderRadius:"50%", background:`radial-gradient(circle, ${cur.bg1} 0%, transparent 70%)`, transition:"background 0.8s ease", animation:"floatY 9s ease-in-out infinite" }}/>
        <div style={{ position:"absolute", bottom:"-10%", right:"-10%", width:"60vw", height:"60vw", maxWidth:400, maxHeight:400, borderRadius:"50%", background:`radial-gradient(circle, ${cur.bg2} 0%, transparent 70%)`, transition:"background 0.8s ease", animation:"floatY 11s ease-in-out infinite reverse" }}/>
        {/* Grade sutil */}
        <svg style={{ position:"absolute", inset:0, width:"100%", height:"100%", opacity:0.025 }} xmlns="http://www.w3.org/2000/svg">
          <defs><pattern id="g" width="48" height="48" patternUnits="userSpaceOnUse"><path d="M48 0L0 0 0 48" fill="none" stroke="white" strokeWidth="0.8"/></pattern></defs>
          <rect width="100%" height="100%" fill="url(#g)"/>
        </svg>
      </div>

      {/* ══════════════════════════════════════════
          FASE 2 — ONBOARDING SLIDES
      ══════════════════════════════════════════ */}
      {phase === "onboarding" && (
        <div
          className={cinematic ? "onboarding-shell onboarding-shell--cinematic" : "onboarding-shell"}
          style={{
            position:"relative", zIndex:1, minHeight:"100vh", display:"flex", flexDirection:"column", overflow:"hidden",
            "--slide-accent": cur.accent, "--slide-accent-2": cur.accent2,
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {cinematic && (
            <div key={slide + "-background"} className="onboarding-cinematic-background" aria-hidden="true">
              <img src={cur.image} alt="" draggable="false" />
              <CinematicMotion id={cur.id} />
              <div className="onboarding-cinematic-vignette" />
              <div className="onboarding-cinematic-glow" />
            </div>
          )}

          {/* ── Barra de progresso no topo ── */}
          <div className="onboarding-progress" style={{ position:"absolute", top:0, left:0, right:0, zIndex:10, padding:"52px 24px 0" }}>
            <div style={{ display:"flex", gap:5 }}>
              {SLIDES.map((_, i) => (
                <div className="onboarding-progress-segment" key={i} style={{ flex:1, height:3, borderRadius:2, background: i <= slide ? cur.accent : "rgba(255,255,255,0.1)", transition:"background 0.4s ease, box-shadow 0.4s ease", boxShadow: i === slide ? `0 0 8px ${cur.accent}88` : "none" }}/>
              ))}
            </div>
          </div>

          {/* ── Header ── */}
          <div className="onboarding-header" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"68px 24px 0", flexShrink:0 }}>
            <img className="onboarding-header-logo" src={logoZuno} alt="Zuno" style={{ height:22, objectFit:"contain", opacity:0.5 }}/>
            <button className="onboarding-skip" onClick={skip} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.3)", fontSize:13, fontWeight:600, cursor:"pointer", padding:"4px 0", letterSpacing:0.3 }}>
              Pular
            </button>
          </div>

          {/* ── Ilustração ── */}
          <div
            key={slide + "-vis"}
            className={cinematic ? "onboarding-visual onboarding-visual--cinematic" : "onboarding-visual"}
            style={{
              flex:1, display:"flex", alignItems:"center", justifyContent:"center",
              padding:"16px 24px 0",
              animation: !transitioning ? (slideDir > 0 ? "slideInR 0.35s cubic-bezier(0.25,0.46,0.45,0.94) both" : "slideInL 0.35s cubic-bezier(0.25,0.46,0.45,0.94) both") : "none",
              opacity: transitioning ? 0 : 1,
              transform: transitioning ? `translate3d(${slideDir > 0 ? -18 : 18}px,0,0)` : "translate3d(0,0,0)",
              transition:"opacity 0.18s ease, transform 0.32s ease",
            }}
          >
            {!cinematic && (
              <div style={{ width:"100%", maxWidth:300, aspectRatio:"1/0.88" }}>
                {cur.visual}
              </div>
            )}
          </div>

          {/* ── Texto ── */}
          <div
            key={slide + "-txt"}
            className={cinematic ? "onboarding-copy onboarding-copy--cinematic" : "onboarding-copy"}
            style={{
              padding:"0 28px", flexShrink:0,
              animation: !transitioning ? "fadeUp 0.4s ease 0.1s both" : "none",
              opacity: transitioning ? 0 : 1,
              transform: transitioning ? `translate3d(${slideDir > 0 ? -14 : 14}px,0,0)` : "translate3d(0,0,0)",
              transition:"opacity 0.18s ease, transform 0.32s ease",
            }}
          >
            {/* Tag */}
            <div className="onboarding-tag" style={{ display:"inline-flex", alignItems:"center", gap:6, marginBottom:14 }}>
              <div style={{ width:20, height:2, borderRadius:1, background:cur.accent }}/>
              <span style={{ fontSize:10, fontWeight:800, letterSpacing:3, color:cur.accent, textTransform:"uppercase" }}>{cur.tag}</span>
            </div>

            {/* Título */}
            <h1 className="onboarding-title" style={{ fontSize:42, fontWeight:900, color:"#fff", lineHeight:1.12, margin:"0 0 14px", whiteSpace:"pre-line", letterSpacing:-1.5 }}>
              {cinematic
                ? cur.title.split("\n").map((line, index, lines) => (
                    <React.Fragment key={line + index}>
                      <span className={index === lines.length - 1 ? "onboarding-title-accent" : undefined}>{line}</span>
                      {index < lines.length - 1 && <br />}
                    </React.Fragment>
                  ))
                : cur.title}
            </h1>

            {/* Subtítulo */}
            <p className="onboarding-subtitle" style={{ fontSize:16, color:"rgba(255,255,255,0.45)", lineHeight:1.65, margin:0 }}>
              {cur.sub}
            </p>
          </div>

          {/* ── Rodapé ── */}
          <div className={cinematic ? "onboarding-footer onboarding-footer--cinematic" : "onboarding-footer"} style={{ padding:"20px 28px 40px", flexShrink:0, display:"flex", alignItems:"center", gap:12 }}>
            {/* Botão voltar */}
            {slide > 0 && (
              <button className="onboarding-back" aria-label="Voltar" onClick={goPrev} style={{ width:50, height:50, borderRadius:"50%", border:`1.5px solid rgba(255,255,255,0.1)`, background:"rgba(255,255,255,0.05)", color:"rgba(255,255,255,0.5)", fontSize:18, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"all 0.2s" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
                </svg>
              </button>
            )}

            {/* Botão avançar */}
            <button
              className="onboarding-next"
              onClick={goNext}
              style={{ flex:1, padding:"16px", borderRadius:16, border:"none", cursor:"pointer", background:`linear-gradient(135deg, ${cur.accent} 0%, ${cur.accent2} 100%)`, color:"#fff", fontSize:16, fontWeight:800, boxShadow:`0 8px 28px ${cur.bg1}`, transition:"all 0.3s", display:"flex", alignItems:"center", justifyContent:"center", gap:10, letterSpacing:0.3 }}
            >
              {slide === SLIDES.length - 1 ? "Começar agora" : "Avançar"}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                {slide === SLIDES.length - 1
                  ? <><polyline points="20 6 9 17 4 12"/></>
                  : <><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></>
                }
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════
          FASE 3 — CTA FINAL
      ══════════════════════════════════════════ */}
      {phase === "cta" && (
        <div style={{ position:"relative", zIndex:1, minHeight:"100vh", display:"flex", flexDirection:"column", justifyContent:"space-between", padding:"0 28px 44px", animation:"fadeIn 0.5s ease both" }}>

          {/* Topo */}
          <div style={{ paddingTop:72, display:"flex", flexDirection:"column", alignItems:"center", gap:10 }}>
            <div className="welcome-motion" style={{ animation:"floatY 3.5s ease-in-out infinite", filter:"drop-shadow(0 0 18px rgba(55,211,255,.26))" }}>
              <img src={logoZuno} alt="Zuno" style={{ height:56, objectFit:"contain" }} />
            </div>
            <span style={{ fontSize:11, color:"rgba(255,255,255,0.2)", letterSpacing:4, textTransform:"uppercase", fontWeight:700 }}>
              Mobilidade para todos
            </span>
          </div>

          {/* Central */}
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:20, textAlign:"center" }}>
            {/* Anel pulsante */}
            <div style={{ position:"relative", width:190, height:190, display:"flex", alignItems:"center", justifyContent:"center", perspective:700 }}>
              <div className="welcome-motion" style={{ position:"absolute", inset:2, borderRadius:"50%", border:"1px solid rgba(40,206,255,.48)", transform:"rotate(22deg)", animation:"welcomeOrbit 12s linear infinite", boxShadow:"0 0 16px rgba(34,211,238,.18)" }}><i style={{position:"absolute",width:8,height:8,borderRadius:"50%",background:"#22d3ee",top:17,left:32,boxShadow:"0 0 13px #22d3ee"}} /></div>
              <div className="welcome-motion" style={{ position:"absolute", inset:16, borderRadius:"50%", border:"1px solid rgba(199,69,255,.48)", transform:"rotate(-36deg)", animation:"welcomeOrbitReverse 9s linear infinite" }}><i style={{position:"absolute",width:7,height:7,borderRadius:"50%",background:"#ec4899",right:13,bottom:38,boxShadow:"0 0 12px #ec4899"}} /></div>
              <div className="welcome-motion" style={{ position:"absolute", inset:29, borderRadius:"50%", border:"1.5px solid rgba(123,97,255,.32)", animation:"pulseRing 2.7s ease-in-out infinite" }}/>
              <div className="welcome-motion" style={{ width:122, height:122, borderRadius:"50%", background:"radial-gradient(circle at 32% 24%,#b8f7ff 0%,#5d7cff 23%,#5433d7 53%,#df3aa8 82%,#11173e 100%)", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"inset -18px -22px 32px rgba(3,5,22,.55), inset 9px 10px 20px rgba(255,255,255,.23), 0 0 20px #258cff, 0 0 48px rgba(139,92,246,.72)", animation:"welcomeSphere 4.2s ease-in-out infinite" }}>
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon className="welcome-motion" style={{animation:"welcomeBolt 2.3s ease-in-out infinite"}} points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
              </div>
            </div>

            <div style={{ animation:"fadeUp 0.5s ease 0.15s both" }}>
              <h2 style={{ fontSize:32, fontWeight:900, color:"#fff", lineHeight:1.2, margin:"0 0 12px", letterSpacing:-0.8 }}>
                Pronto para{"\n"}começar?
              </h2>
              <p style={{ fontSize:14, color:"rgba(255,255,255,0.35)", lineHeight:1.7, margin:0 }}>
                Faça parte de uma nova era da mobilidade urbana. Simples, justo e para todos.
              </p>
            </div>

            {/* Badges */}
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", justifyContent:"center", animation:"fadeUp 0.5s ease 0.25s both" }}>
              {[["🔒","Seguro"],["⚡","Rápido"],["💚","Justo"],["🏆","Premium"]].map(([icon,label]) => (
                <div className="welcome-motion" key={label} style={{ width:72, minHeight:66, padding:"9px 6px", borderRadius:16, background:"linear-gradient(145deg,rgba(19,31,72,.8),rgba(9,12,35,.72))", border:"1px solid rgba(104,116,255,.3)", boxShadow:"inset 0 1px rgba(255,255,255,.06),0 9px 24px rgba(2,5,20,.38)", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", gap:5, animation:`welcomeCard 4s ease-in-out infinite ${label.length * .08}s` }}>
                  <span style={{ fontSize:13 }}>{icon}</span>
                  <span style={{ fontSize:12, color:"rgba(255,255,255,0.4)", fontWeight:600 }}>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Botões */}
          <div style={{ display:"flex", flexDirection:"column", gap:12, animation:"fadeUp 0.5s ease 0.3s both" }}>
            <button className="welcome-motion" onClick={handleEntrar} style={{ width:"100%", padding:"17px", borderRadius:16, border:"1px solid rgba(133,235,255,.72)", background:"linear-gradient(110deg,#08bdea,#4167ff,#b634e7,#f052aa)", backgroundSize:"220% 220%", animation:"welcomeButtonGlow 5s ease infinite", color:"#fff", fontSize:16, fontWeight:800, cursor:"pointer", boxShadow:"0 0 18px rgba(15,196,255,.34),0 12px 36px rgba(124,58,237,0.4)", display:"flex", alignItems:"center", justifyContent:"center", gap:10, letterSpacing:0.3 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
              Entrar na conta
            </button>
            <button onClick={handleEntrar} style={{ width:"100%", padding:"16px", borderRadius:16, cursor:"pointer", background:"rgba(255,255,255,0.04)", border:"1.5px solid rgba(168,85,247,0.3)", color:"#c084fc", fontSize:16, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", gap:10, transition:"all 0.2s" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#c084fc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
              </svg>
              Criar conta grátis
            </button>
            <p style={{ textAlign:"center", fontSize:12, color:"rgba(255,255,255,0.12)", margin:"2px 0 0" }}>
              Suporte: <a href="tel:+5511917934340" style={{ color:"rgba(168,85,247,0.6)", textDecoration:"none", fontWeight:700 }}>(11) 91793-4340</a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  root: {
    minHeight: "100vh",
    width: "100%",
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    position: "relative",
    overflow: "hidden",
    maxWidth: 480,
    margin: "0 auto",
  },
};
